export enum LoginStatus {
  Loading,
  Error,
  LoggedIn,
}
